import { cn } from "@/lib/utils";
import { Typography } from "../ui/typography";

interface PaginationCounterProps {
  current: number;
  total: number;
  className?: string;
}

export function PaginationCounter({
  current,
  total,
  className,
}: PaginationCounterProps) {
  return (
    <div
      className={cn(
        "absolute text-white bottom-5 left-4 z-10 px-1 py-0.5 rounded-[5px] bg-black-500/50 text-sm font-medium md:font-bold",
        className
      )}
    >
      {current}/{total}
    </div>
  );
}
